import React from 'react';

import customLocalStorage from '../services/localStorageWithExpire';

import api, { LoginPayload, SignupPayload } from '../api/auth';
import { AxiosError } from 'axios';


interface AuthContextType {
    user: LoginPayload | undefined;
    hasToken: boolean | undefined;
    signin: (payload: LoginPayload, callback: VoidFunction) => Promise<void>;
    signout: (callback: VoidFunction) => Promise<void>;
    signup: (payload: SignupPayload, callback: VoidFunction) => Promise<void>;
}

export let AuthContext = React.createContext<AuthContextType | null>(null);

const AuthProvider = ({ children }: { children: React.ReactNode }) => {
    const [user, setUser] = React.useState<any>();
    const [hasToken, setHasToken] = React.useState<boolean | undefined>();

    React.useEffect(() => {
        let token = customLocalStorage.getToken("ACCESS_TOKEN"); // customLocalStorage.getWithExpire("ACCESS_TOKEN");
        if (token && 'value' in token) {

            const userInfo = parseJWT(token.value);
            const keyLength = Object.keys(userInfo).length;

            if (keyLength > 0) {                
                setUser(userInfo);
                setHasToken(true);
            }            
        }
    }, []);
    //let token = customLocalStorage.getWithExpire("ACCESS_TOKEN");
    // const [user, setUser] = React.useState<any>(() => {
    //     if (token) return parseJWT(token);
    // });
    // const [hasToken, setHasToken] = React.useState<boolean>(() => !!token);

    const signin = async (payload: LoginPayload, callback: VoidFunction) => {
        // fetch login api to get token
        try {
            await api.login(payload);
        } catch (err: any) {
            throw new AxiosError({ ...err.message });
        }

        // get token from local storage
        let bearer = customLocalStorage.getWithExpire("ACCESS_TOKEN");
        if (!bearer) {
            //return window.location.href = "/";
            return;
        }

        let userData = parseJWT(bearer);
        setUser(userData);
        setHasToken(true);
        callback();
    }

    const signup = async (payload: SignupPayload, callback: VoidFunction) => {
        try {
            await api.signup(payload);
        } catch (err: any) {
            throw new AxiosError({ ...err.message })
        }

        callback();
    }

    const signout = async (callback: VoidFunction) => {

        try {
            await api.logout();
            // remove user
            setUser(null);
            setHasToken(false);
            localStorage.clear();
            document.cookie = "token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;"
            callback();
        } catch (err: any) {
            throw new AxiosError({ ...err.message })
        }                
    }

    let value = { user, hasToken, signin, signup, signout };

    return (
        <AuthContext.Provider value={value}>{children}</AuthContext.Provider>
    );
}

const parseJWT = (token: string) => {
    if (!token) return {};

    // get token from bearer
    let realToken = token.split(" ")[1];

    // get the second part of token (payload)
    let payloadInBase64 = realToken.split(".")[1];
    let base64 = payloadInBase64.replace(/-/g, '+').replace(/_/g, '/');
    let jsonPayload = decodeURIComponent(window.atob(base64).split('').map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)).join(''));

    try {
        return JSON.parse(jsonPayload);
    }
    catch (err) {
        return {};
    }
}

export default AuthProvider;